import { axios, baseURL } from "./axios.dashboard"

const BranchStrength = async (branchCode) => {
    return await axios
        .post( baseURL+"branchDetails/BR_STRENGTH", {
            branchCode: branchCode
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

const BranchPolSumry = async (branchCode) => {
    return await axios
        .post( baseURL+"branchDetails/BR_POL_SMRY", {
            branchCode: branchCode
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

export { BranchStrength, BranchPolSumry }